import { Activity, ActivityType } from '../types';

export const ActivityMap: {
	[key in ActivityType]: Pick<Activity, 'type' | 'content'>;
} = {
	create: {
		type: 'create',
		content: 'activity.type.create',
	},
	delete: {
		type: 'delete',
		content: 'activity.type.delete',
	},
	update: {
		type: 'update',
		content: 'activity.type.updated',
	},
	archive: {
		type: 'archive',
		content: 'activity.type.archive',
	},
	unarchive: {
		type: 'unarchive',
		content: 'activity.type.unarchive',
	},
	restore: {
		type: 'restore',
		content: 'activity.type.restore',
	},
	share: {
		type: 'share',
		content: 'activity.type.share',
	},
	'revoke-share': {
		type: 'revoke-share',
		content: 'activity.type.revoke-share',
	},
	ownership: {
		type: 'ownership',
		content: 'activity.type.ownership',
	},
	'revoke-ownership': {
		type: 'revoke-ownership',
		content: 'activity.type.revoke-ownership',
	},
	disable: {
		type: 'disable',
		content: 'activity.type.disable',
	},
	enable: {
		type: 'enable',
		content: 'activity.type.enable',
	},
	'move-to': {
		type: 'move-to',
		content: 'activity.type.move-to',
	},
	status: {
		type: 'status',
		content: 'activity.type.status',
	},
	thumbnail: {
		type: 'thumbnail',
		content: 'activity.type.thumbnail',
	},
	'set-as-thumbnail': {
		type: 'set-as-thumbnail',
		content: 'activity.type.set-as-thumbnail',
	},
	'remove-as-thumbnail': {
		type: 'remove-as-thumbnail',
		content: 'activity.type.removed-as-thumbnail',
	},
	'create-external-link': {
		type: 'create-external-link',
		content: 'activity.type.create-external-link',
	},
	'remove-external-link': {
		type: 'remove-external-link',
		content: 'activity.type.removed-external-link',
	},
};
